// src/components/StudentsDashboard/StudentsDashboard.jsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Row, Col } from "react-bootstrap";
import Header from "../../components/Header/Header";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import { hooks } from "../../components/../studentportal-sdk";
/* eslint-disable */


const StudentsDashboard = (props) => {
  const [feedback, setFeedback] = useState({ success: null, message: "" });
  const [data, setObject] = useState({
    chart: {
      height: 350,
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    datasets: {
      id: "apexcharts-area",
    },
    stroke: {
      curve: "smooth",
    },
    colors: ["#3D5EE1", "#70C4CF"],
    borderWidth: 3,
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
  });
  const [series, setSeries] = useState([
    {
      name: "Teachers",
      data: [45, 60, 75, 51, 42, 42, 30],
    },
    {
      name: "Students",
      data: [24, 48, 56, 32, 34, 52, 25],
    },
  ]);
  const [date, setDate] = useState(new Date());

  // Sample data for course library
  const courseLibrary = [
    {
      id: 1,
      name: "Introduction to XYZ",
      type: "PDF",
      url: "/files/introduction-to-xyz.pdf",
    },
    {
      id: 2,
      name: "Advanced Concepts",
      type: "Video",
      url: "/videos/advanced-concepts.mp4",
    },
    {
      id: 3,
      name: "Lesson Plan",
      type: "Doc",
      url: "/files/lesson-plan.docx",
    },
    // Add more files as needed
  ];
 
  const {
    userService: {
      store: { role , authUser},
    },
    courseService: {
      store: { courseDocs },
      action: { storeCourseAction },
    },
    liveSessionService: {
      store: { liveClassDoc },
    },
  } = props;

  const [currentCourse, setCurrentCourse] = useState(null);
  const [liveClass, setLiveClass] = useState(null);

  useEffect(() => {
    courseDocs && setCurrentCourse(courseDocs[courseDocs.length - 1]);
    liveClassDoc && setLiveClass(liveClassDoc[liveClassDoc.length - 1]);
  });


  return (
    <div className="main-wrapper">
      {/* Header */}
      <Header {...authUser} />

      {/* Sidebar */}
      {role === "user" && <CourseSidebar />}

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header mb-4">
            <Row>
              <Col>
                <h3 className="page-title">Welcome, Student</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admindashboard">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">Dashboard</li>
                </ul>
              </Col>
            </Row>
          </div>
          {/* /Page Header */}

          {/* Feedback Alert */}
          {/* {feedback.success && (
            <Alert
              variant="success"
              onClose={() => setFeedback({ success: null, message: "" })}
              dismissible
            >
              {feedback.message}
            </Alert>
          )} */}
          {/* /Feedback Alert */}

          {/* Overview Section */}
          <Row className="mb-4">
            {/* Current Course Card */}
            <Col md={6} lg={4} className="mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-3">Current Course</h5>
                  <h4 className="text-primary">{currentCourse?.title}</h4>
                  {/* <p className="mt-2">Progress: 5/10 lessons completed</p> */}
                  <Button
                    as={Link}
                    to="#"
                    variant="primary"
                    className="mt-3"
                    onClick={() =>
                      storeCourseAction({
                        id: currentCourse.id,
                        action: "view",
                      })
                    }
                  >
                    Continue Course
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            {/* /Current Course Card */}

            {/* Upcoming Live Session Card */}
            <Col md={6} lg={4} className="mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-3">Upcoming Live Session</h5>
                  <h4 className="text-warning">{liveClass?.title}</h4>
                  <p className="mt-2">
                    Date: {new Date(liveClass?.startDate).toLocaleDateString()}
                  </p>
                  <Button
                    href={liveClass?.link}
                    variant="warning"
                    className="mt-3"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Join Session
                  </Button>
                </Card.Body>
              </Card>
            </Col>
            {/* /Upcoming Live Session Card */}

            {/* Additional Overview Cards (Optional) */}
            <Col md={6} lg={4} className="mb-4">
              <Card className="shadow-sm h-100">
                <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-3">Assessments</h5>
                  {/* <h4 className="text-success">40/60</h4>
                  <p className="mt-2">Keep up the good work!</p> */}
                  <Button
                    as={Link}
                    to="/assessments"
                    variant="success"
                    className="mt-3"
                  >
                    View Assessments
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* /Overview Section */}

          {/* Announcements Section */}
          {/* <Card className="mb-4 shadow-sm">
            <Card.Header>
              <h5>Latest Announcements</h5>
            </Card.Header>
            <Card.Body>
              <ul className="list-unstyled mb-0">
                <li className="mb-3 d-flex align-items-start">
                  <FeatherIcon
                    icon="alert-circle"
                    className="text-danger me-2 mt-1"
                    size={20}
                  />
                  <div>
                    <strong>New Assignment:</strong> Complete the assessment by
                    5th September.
                  </div>
                </li>
                <li className="mb-3 d-flex align-items-start">
                  <FeatherIcon
                    icon="calendar"
                    className="text-primary me-2 mt-1"
                    size={20}
                  />
                  <div>
                    <strong>Live Session:</strong> Next live session on
                    "Evangelism" on 10th January.
                  </div>
                </li>
                <li className="d-flex align-items-start">
                  <FeatherIcon
                    icon="award"
                    className="text-success me-2 mt-1"
                    size={20}
                  />
                  <div>
                    <strong>Quiz Results:</strong> Your latest quiz results are
                    available now.
                  </div>
                </li>
              </ul>
            </Card.Body>
          </Card> */}
          {/* /Announcements Section */}

          {/* Course Library Section */}
          {/* <Card className="shadow-sm mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5>Course Library</h5>
              <Link
                to="/library/add"
                className="btn btn-sm btn-outline-secondary"
              >
                <FeatherIcon icon="plus" className="me-1" />
                Add Material
              </Link>
            </Card.Header>
            <Card.Body>
              {courseLibrary.length > 0 ? (
                <div className="table-responsive">
                  <Table hover className="align-middle">
                    <thead>
                      <tr>
                        <th>File Name</th>
                        <th>Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {courseLibrary.map((file) => (
                        <tr key={file.id}>
                          <td>
                            {file.type === "PDF" && (
                              <FeatherIcon
                                icon="file-text"
                                className="me-2 text-danger"
                              />
                            )}
                            {file.type === "Video" && (
                              <FeatherIcon
                                icon="video"
                                className="me-2 text-warning"
                              />
                            )}
                            {file.type === "Doc" && (
                              <FeatherIcon
                                icon="file"
                                className="me-2 text-primary"
                              />
                            )}
                            {file.name}
                          </td>
                          <td>
                            <Badge
                              bg={
                                file.type === "PDF"
                                  ? "danger"
                                  : file.type === "Video"
                                    ? "warning"
                                    : "primary"
                              }
                            >
                              {file.type}
                            </Badge>
                          </td>
                          <td>
                            <Button
                              as="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              variant="outline-primary"
                              size="sm"
                              className="me-2"
                            >
                              <FeatherIcon icon="download" className="me-1" />
                              Download
                            </Button>
                            {file.type === "Video" && (
                              <Button
                                as={Link}
                                to={file.url}
                                variant="outline-success"
                                size="sm"
                              >
                                <FeatherIcon
                                  icon="play-circle"
                                  className="me-1"
                                />
                                Watch
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <p className="text-center">No course materials available.</p>
              )}
            </Card.Body>
          </Card> */}
          {/* /Course Library Section */}

          {/* Footer */}
          <footer className="text-center py-3">
            <p>Copyright © 2024</p>
          </footer>
          {/* /Footer */}
        </div>
      </div>
    </div>
  );
};

export default (props) => (
  <StudentsDashboard {...hooks.UserManagement(props)} />
);
